var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLobby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lobby",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.61,
    height: 100.61,
    viewBox: "0 0 100.61 100.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #2d3539;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-1",
    d: "M217.5,348.345a2.408,2.408,0,1,0,1.7-.7A2.408,2.408,0,0,0,217.5,348.345Z",
    transform: "translate(-173.572 -278.328)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-1",
    d: "M439.884,393.55a2.411,2.411,0,1,0,1.7.707A2.411,2.411,0,0,0,439.884,393.55Z",
    transform: "translate(-352.272 -315.085)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-1",
    d: "M98.644,52.271H89.992V35.785A9.86,9.86,0,0,0,82.3,26.213L75.876,24.8a10.284,10.284,0,0,0,3.606-7.821V10.309a10.308,10.308,0,1,0-20.617,0v6.676a10.283,10.283,0,0,0,3.6,7.816l-6.423,1.408a9.86,9.86,0,0,0-7.7,9.572v8.628H37.729a1.968,1.968,0,0,0-1.966,1.966v5.9H22.009v-5.5h8.25A1.966,1.966,0,0,0,32.225,44.8V23.581a1.966,1.966,0,0,0-1.966-1.966H1.966A1.964,1.964,0,0,0,0,23.581V44.8a1.964,1.964,0,0,0,1.966,1.964h8.25v5.5H1.966A1.964,1.964,0,0,0,0,54.235v9.433a1.964,1.964,0,0,0,1.966,1.964H8.652V98.644a1.964,1.964,0,0,0,1.958,1.966H90a1.964,1.964,0,0,0,1.964-1.966V89.016a1.966,1.966,0,0,0-3.93,0V96.68H12.576v-22.8H37.729a1.966,1.966,0,1,0,0-3.93H12.576v-4.32H88.034V73.3a1.966,1.966,0,0,0,3.93,0V65.632h6.681a1.964,1.964,0,0,0,1.966-1.964V54.235a1.964,1.964,0,0,0-1.966-1.964ZM62.791,15.593h2.7a18.076,18.076,0,0,0,10.061-3.018v4.411a6.379,6.379,0,1,1-12.757,0Zm6.379,11.7a10.314,10.314,0,0,0,1.793-.159l-1.811,4.093-1.821-4.1A10.334,10.334,0,0,0,69.169,27.293Zm0-23.364A6.389,6.389,0,0,1,75.1,7.954a14.174,14.174,0,0,1-9.6,3.717h-2.7V10.309A6.387,6.387,0,0,1,69.169,3.93Zm-16.9,31.851a5.9,5.9,0,0,1,4.61-5.733l6.781-1.487,3.688,8.3a1.966,1.966,0,0,0,3.592,0l3.688-8.306,6.823,1.493a5.9,5.9,0,0,1,4.614,5.733V52.271H64.847v-5.9a1.968,1.968,0,0,0-1.966-1.966H52.271ZM39.691,48.339H60.915v3.932H39.695ZM3.93,25.555H28.3V42.848H21.977a5.9,5.9,0,0,0-11.729,0H3.93ZM14.148,43.464a1.966,1.966,0,1,1,3.93,0v8.828h-3.93ZM96.68,61.722H3.93V56.2H96.68Z",
    transform: "translate(0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLobby);
export default __webpack_public_path__ + "static/media/Lobby.4ff1db450f1dbee6567ce0e9e19887b9.svg";
export { ForwardRef as ReactComponent };